<script>
    import { onMount } from 'svelte';
    import { firestore, storage } from "../firebase/firebase.js";
    import { navigateTo, Navigate } from "svelte-router-spa";
    import { user, userProfile } from "../store/auth.js";
    import { liveCountries } from "../store/shared.js"

    export let currentRoute;
    export let params;

    var adId = '';
    var viewedAd;
    var adImage;
    var title = '';
    var iosURL = '';
    var androidURL = '';
    var isDisabled = false;
    var loading = false;
    var deleteLoading = false;
    var canFetch = false;
    let selectedCountries = {};

    $: {
        if ($liveCountries && $liveCountries.length > 0) {
            setLiveCountries();
        }
        if ($userProfile)
            init();
    }

    function setLiveCountries() {
        for (let i = 0; i < $liveCountries.length; i++) {
            const country = $liveCountries[i];
            if (!selectedCountries[country.id]) {
                selectedCountries[country.id] = [];
            }
        }
    }

    async function init() {
        try {
            adId = currentRoute.namedParams['id'];
            if ($userProfile) {
                if ($userProfile.role == 'admin') {
                    canFetch = true;
                }
            }
            if (canFetch) {
                if (adId != 'new') {
                    loading = true;
                    await fetchAd(adId)
                    loading = false;
                }
            }
        } catch (error) {

        }
    }

    async function fetchAd(adId) {
        try {
            var temp = await firestore.collection('in-app-ads').doc(adId).get();
            if (temp && temp.exists && temp.data()) {
                viewedAd = temp
                var data = viewedAd.data();
                title = data.title
                iosURL = data.ios_url
                androidURL = data.android_url
                isDisabled = data.is_disabled
                var tempCountries = {}
                if (data.countries) {
                    for (const countryId in data.countries) {
                        if (data.countries.hasOwnProperty(countryId)) {
                            const countryLangs = data.countries[countryId];
                            tempCountries[countryId] = countryLangs && countryLangs.length > 0 ? countryLangs : []
                        }
                    }
                }
                selectedCountries = { ...tempCountries }
                if (data.image) {
                    adImage = { ...data.image }
                }
            }
        } catch (error) {
        }
    }

    async function createAd() {
        try {
            if (!loading) {
                var result = validateAd();
                if (result) {
                    loading = true;
                    uploadNewImage()
                        .then(async result => {
                            var temp = { ...result }
                            if (temp.file) delete temp.file;
                            if (temp.isNew == true || temp.isNew == false) delete temp.isNew;
                            var res = await firestore.collection('in-app-ads').add({
                                title: title,
                                ios_url: iosURL,
                                android_url: androidURL,
                                is_disabled: isDisabled,
                                image: temp,
                                countries: selectedCountries,
                                created_at: new Date()
                            })
                                .then(async result => {
                                    if (result && result.id) {
                                        adId = result.id
                                        await fetchAd(result.id)
                                        navigateTo("/admin/in-app-ads/" + result.id);
                                    }
                                })
                                .catch(error => {

                                })
                                .finally(() => {
                                    loading = false;
                                })
                        })
                        .catch(error => {
                            loading = false;
                        })
                }
            }
        } catch (error) {
            loading = false;
        }
    }

    function updateAd() {
        try {
            if (!loading) {
                var result = validateAd();
                if (result) {
                    loading = true;
                    uploadNewImage()
                        .then(async result => {
                            var temp = { ...result }
                            if (temp.file) delete temp.file;
                            var res = await firestore.collection('in-app-ads').doc(adId).set({
                                title: title,
                                ios_url: iosURL,
                                android_url: androidURL,
                                is_disabled: isDisabled,
                                image: temp,
                                countries: selectedCountries,
                            }, { merge: true })
                                .then(async result => {
                                    await fetchAd(adId)
                                })
                                .catch(error => {

                                })
                                .finally(() => {
                                    loading = false;
                                })
                        })
                        .catch(error => {
                            loading = false;
                        })
                }
            }
        } catch (error) {
            loading = false;
        }
    }

    async function deleteAd() {
        if (!deleteLoading) {
            try {
                deleteLoading = true;
                await firestore.collection('in-app-ads').doc(adId).delete();
                deleteLoading = false;
                navigateTo("/admin/in-app-ads");
            } catch (error) {
                deleteLoading = false;
            }
        }
    }

    function validateAd() {
        var isValid = true;
        try {
            if (!adImage || !title || title.length <= 0) {
                isValid = false;
            }
        } catch (error) {
            isValid = false;
        }
        return isValid;
    }

    function openFilePicker() {
        try {
            var element = document.getElementById('adImageInput')
            element.click();
        } catch (error) {
        }
    }

    async function uploadNewImage() {
        return new Promise(async (resolve, reject) => {
            try {
                if (adImage && adImage.isNew) {
                    if (adImage.file && adImage.id) {
                        var fileRef = storage.ref("/in-app-ads/" + adImage.id);
                        var task = fileRef.put(adImage.file);
                        if (task) {
                            task.on(
                                "state_changed",
                                function progress(snapshot) {
                                    var progress = Math.round(
                                        (snapshot.bytesTransferred / snapshot.totalBytes) * 100
                                    );
                                },

                                function error(error) {
                                },

                                async function complete() {
                                    await task.ref_
                                        .getDownloadURL()
                                        .then(downloadedUrl => {
                                            resolve({
                                                ...adImage,
                                                isNew: false,
                                                url: downloadedUrl
                                            });
                                        })
                                        .catch(e => { });
                                }
                            );
                        }
                    } else reject()
                } else {
                    resolve(adImage);
                }
            } catch (error) {
                reject(error)
            }
        })
    }

    function loadadImage(event) {
        try {
            if (event && event.target && event.target.files) {
                if (event.target.files && event.target.files.length > 0) {
                    const pic = event.target.files[0];
                    adImage = {
                        file: pic,
                        title: pic.name,
                        isNew: true,
                        url: '',
                        id: Date.now().toString() + '_' + '_' + pic.name,
                    }
                    setTimeout(() => {
                        try {
                            var image = document.getElementById(adImage.id);
                            image.src = URL.createObjectURL(adImage.file);
                        } catch (error) {

                        }
                    }, 100)
                    this.key = Date.now()
                }
            }
        } catch (error) {

        }
    }
</script>

{#if canFetch}
<div class:loading={loading} class:deleteLoading={deleteLoading} class="ad-container">
    <div class="header">
        {#if viewedAd}
            <div>
                Ad Preview            
            </div>
                <div class="my_btn_group">
                    <div class="mr-1">
                        {#if deleteLoading}
                        <button class="btn btn-outline-danger btn-sm" type="button">
                            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                            <span class="sr-only">Loading...</span>
                        </button>
                    {:else}
                        <button on:click="{deleteAd}" type="button" class="btn btn-outline-danger btn-sm">DELETE</button>
                    {/if}
                    </div>
                    <div>
                        {#if loading}
                <button class="btn btn-outline-primary btn-sm" type="button">
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                    <span class="sr-only">Loading...</span>
                </button>
            {:else}
                <button on:click="{updateAd}" type="button" class="btn btn-outline-primary btn-sm">UPDATE</button>
            {/if}
                    </div>
                </div>
        {:else}
            <div>
                New Ad 
            </div>
            {#if loading}
                <button class="btn btn-outline-primary btn-sm" type="button">
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                    <span class="sr-only">Loading...</span>
                </button>
            {:else}
                <button on:click="{createAd}" type="button" class="btn btn-outline-primary btn-sm">CREATE</button>
            {/if}
        {/if}
    </div>

    

    <form class="ad_form">
        <div class="row no-gutters" style="justify-content: space-between !important;">
            <div class="col-lg-4 col-md-6 col-sm-12 col-xs-12 mb-2" >
                <!-- image -->
                <div class="image_section" :key="key">
                    {#if !adImage}
                        <div class="ad_image_input" on:click="{openFilePicker}">
                            Select Image
                        </div>
                    {:else}
                        <div class="image_wrapper">
                            <button  on:click="{openFilePicker}" type="button" class="btn btn-dark btn-sm override_image_btn">New</button>
                            {#if adImage.isNew}
                                <img class="picked_image" id="{adImage.id}" />
                            {:else}
                                <img class="picked_image" src="{adImage['url']}" />
                            {/if}
                        </div>
                    {/if}
                </div>

                
            </div>
            <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12" >
               <!-- title -->
               <div>
                <div class="row no-gutters mb-2">
                    <div class="col">
                        <div class="form-group">
                            <label style="padding-bottom: 10px;" for="ad_title">Title</label>
                            <input bind:value={title} type="text" class="form-control" id="ad_title" placeholder="Title" />
                        </div>
                    </div>
                </div>
                <div class="row no-gutters mb-2">
                    <div class="col">
                        <div class="form-group">
                            <label style="padding-bottom: 10px;" for="ios_url">ios URL</label>
                            <input bind:value={iosURL} type="url" class="form-control" id="ios_url" placeholder="ios Url" />
                        </div>
                    </div>
                </div>
                <div class="row no-gutters mb-2">
                    <div class="col">
                        <div class="form-group">
                            <label style="padding-bottom: 10px;" for="android_url">Android URL</label>
                            <input bind:value={androidURL} type="url" class="form-control" id="android_url" placeholder="Android Url" />
                        </div>
                    </div>
                </div>
                <div class="row no-gutters">
                    <div class="col">
                        <div class="form-group">
                            <div class="custom-control custom-checkbox">
                                <input bind:checked={isDisabled} type="checkbox" class="custom-control-input" id="is_available">
                                <label class="custom-control-label" for="is_available">Is Disabled</label>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- countries and langs -->
                <div class="row no-gutters">
                    <div class="col">
                        <div class="form-group">
                            <label style="padding-bottom: 10px;" for="countries">Countries & Languages</label>
                            <div id="countries">
                                {#if $liveCountries && $liveCountries.length != 0}
                                    <ul class="list-group">
                                        {#each $liveCountries as country, i}
                                            <i class="list-group-item-secondary" data-toggle="collapse" data-target="{'#collapse_' + i}" aria-expanded="false" aria-controls="{'#collapse_' + i}" style="cursor: pointer; text-align: left !important; font-size: 13px; width: 100% !important;" class:list-group-item="{true}" class:list-group-item-action="{true}">
                                                <b>{ country['name'] }</b>
                                            </i>
                                            <div style="padding: 10px 0 10px 10px;" class="collapse" id="{'collapse_' + i}">
                                                {#if selectedCountries[country.id] && selectedCountries[country.id].length >= 0}
                                                    <select bind:value="{selectedCountries[country.id]}" id="lang_select" class="custom-select" multiple>
                                                        {#each country['liveLanguages'] as lang, i}
                                                            <option value="{lang['code']}">{ lang['name'] }</option>
                                                        {/each}
                                                    </select>
                                                {/if}
                                            </div>
                                        {/each}
                                    </ul>
                                
                                {:else}
                                    <div style="width: 100%; display: flex; font-size: 13px;">
                                        <span class="text-secondary" style="text-align: center; width: 100%;">No countires</span>
                                    </div>
                                {/if}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            </div>
        </div>
    </form>
    <input on:change="{loadadImage}" multiple="false" accept="image/*" class="ad_image_input_hid" type="file"
    id="adImageInput">
    
</div>
{/if}


<style>
    .ad-container {
        border-right: 1px solid #f4f4f4;
        height: 100%;
    }

    .ad_form{
        padding: 20px 40px;
    }

    .cards_list_wrapper{
        padding: 20px 40px;
    }

    .image_section {
        min-height: 350px;
        width: 100%;
        display: flex;
        justify-content: center;
        align-content: center;
    }
    .ad_image_input_hid{
        visibility: hidden;
        max-width: 0px;
        width: 0px;
        max-height: 0px;
        height: 0px;
    }

    .ad_image_input{
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        background: #eaeaea;
        color: #313131;
        cursor: pointer;
    }

    .picked_image{
        width: 100%;
        height: auto;
        object-fit: cover;
    }

    .image_wrapper{
        position: relative;
        width: 100%;
    }

    .override_image_btn{
        position: absolute;
        top: 5px;
        left: 5px;
    }

    .header {
        background-color: #efefef;
        display: block;
        width: 100%;
        min-height: 68px;
        border-bottom: 1px solid #e7e7e7;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 10px;
    }

    .center{
        margin: 0 auto !important;
    }

    .loading{
        pointer-events: none;
        opacity: 0.5;
    }
    .deleteLoading{
        pointer-events: none;
        opacity: 0.5;
    }
    .my_btn_group{
        display: flex;
    }

    .ltr_cards{
        direction: ltr !important;
    }

    .rtl_cards{
        direction: rtl !important;
    }
</style>